import React from "react";
import {
  Icon,
  IconNames,
  Paragraph,
  useColorTokens
} from "@tvg/design-system/src";
import { Handicapping, Timeform } from "@tvg/ts-types/Race";
import { pickIcon, PICKS_DATA_SOURCE, QA_LABELS } from "./constants";
import {
  Container,
  ContainerAnalyst,
  ParagraphContainer
} from "./styled-components";

interface Props {
  trackDataSource?: string;
  timeform?: Timeform;
  handicapping?: Handicapping;
}

const InlineAnalyses = ({ trackDataSource, timeform, handicapping }: Props) => {
  const colorTokens = useColorTokens();
  const handicappingAnalyse = handicapping?.freePick?.info ?? null;
  const timeformAnalyse = timeform?.analystsComments ?? null;

  const getIconName = () => {
    if (handicapping?.freePick?.number !== null || timeformAnalyse !== null) {
      return pickIcon[trackDataSource as string] || pickIcon.default;
    }

    return pickIcon.default;
  };

  return (
    <Container>
      {trackDataSource !== PICKS_DATA_SOURCE.USGSA ? (
        <ContainerAnalyst data-qa-label={QA_LABELS.CONTAINER}>
          {handicappingAnalyse !== null && handicappingAnalyse !== "" && (
            <ParagraphContainer
              data-qa-label={"handicapping-" + QA_LABELS.PARAGRAPH_CONTAINER}
            >
              <Icon
                name={getIconName() as IconNames}
                size="s"
                qaLabel={"handicapping-" + QA_LABELS.ICON}
              />
              <Paragraph
                color={colorTokens.content.subtle}
                paddingLeft="space-3"
                qaLabel={"handicapping-" + QA_LABELS.PARAGRAPH}
              >
                <>{handicappingAnalyse}</>
              </Paragraph>
            </ParagraphContainer>
          )}
          {(handicappingAnalyse === null || handicappingAnalyse === "") &&
            timeformAnalyse !== null &&
            timeformAnalyse !== "" && (
              <ParagraphContainer
                data-qa-label={"handicapping-" + QA_LABELS.PARAGRAPH_CONTAINER}
              >
                <Icon
                  name={getIconName() as IconNames}
                  size="s"
                  qaLabel={"handicapping-" + QA_LABELS.ICON}
                />
                <Paragraph
                  color={colorTokens.content.subtle}
                  paddingLeft="space-3"
                  qaLabel={"handicapping-" + QA_LABELS.PARAGRAPH}
                >
                  <>{timeformAnalyse}</>
                </Paragraph>
              </ParagraphContainer>
            )}
        </ContainerAnalyst>
      ) : (
        <ContainerAnalyst data-qa-label={QA_LABELS.CONTAINER}>
          {timeformAnalyse !== null && timeformAnalyse !== "" && (
            <ParagraphContainer
              data-qa-label={"timeform-" + QA_LABELS.PARAGRAPH_CONTAINER}
            >
              <Icon
                name="numberFire"
                size="s"
                qaLabel={"timeform-" + QA_LABELS.ICON}
              />
              <Paragraph
                color={colorTokens.content.subtle}
                qaLabel={"timeform-" + QA_LABELS.PARAGRAPH}
                paddingLeft="space-3"
              >
                <>{timeformAnalyse}</>
              </Paragraph>
            </ParagraphContainer>
          )}
          {handicappingAnalyse !== null && handicappingAnalyse !== "" && (
            <ParagraphContainer
              data-qa-label={"handicapping-" + QA_LABELS.PARAGRAPH_CONTAINER}
            >
              <Icon
                name="trackMaster"
                size="s"
                qaLabel={"handicapping-" + QA_LABELS.ICON}
              />
              <Paragraph
                color={colorTokens.content.subtle}
                qaLabel={"handicapping-" + QA_LABELS.PARAGRAPH}
                paddingLeft="space-3"
              >
                <>{handicappingAnalyse}</>
              </Paragraph>
            </ParagraphContainer>
          )}
        </ContainerAnalyst>
      )}
    </Container>
  );
};

export default InlineAnalyses;
